export default __webpack_public_path__ + "static/media/keyboard_arrow_left.4358a5e9.svg";